import WorkoutProgressBar from './WorkoutProgressBar';

export default WorkoutProgressBar;
